import { createHashHistory } from 'history';
import { Route, Router, Switch } from 'react-router-dom';
import { SatisfactionSurveyResponseSubmitted } from '../../components/surveys/SatisfactionSurveyResponseSubmitted';
import { CustomSurvey } from '../CustomSurvey';
import { RegisterForEvent } from '../RegisterForEvent';
import { SurveyUnavailable } from '../SurveyUnavailable';
import { TakeSurvey } from '../TakeSurvey';

export const AppHashHistory = createHashHistory();

export const SurveysRouter = () => {
	return (
		<Router history={AppHashHistory}>
			<Switch>
				<Route path='/survey/unavailable'>
					<SurveyUnavailable />
				</Route>
				<Route path='/survey/:token?/submitted'>
					<SatisfactionSurveyResponseSubmitted />
				</Route>
				<Route path='/survey/:token?'>
					<TakeSurvey />
				</Route>
				<Route path='/event/:token?'>
					<RegisterForEvent />
				</Route>
				<Route path='/custom-survey/:token?'>
					<CustomSurvey />
				</Route>
			</Switch>
		</Router>
	);
};
